import { FC, useCallback, ReactElement } from 'react';
import { DropResult } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';
import { moveScene } from 'modules/scenes';
import { Scene } from 'types/Scene';

export type DragDropSceneWrapperProps = {
  children: (dropSceneHandler: (result: DropResult) => void) => ReactElement<HTMLElement>;
  scenes: Scene[];
  currentSceneId: string;
};

export const DragDropSceneWrapper: FC<DragDropSceneWrapperProps> = ({ children }) => {
  const dispatch = useDispatch();

  const dropSceneHandler = useCallback((result: DropResult) => {
    if (!result.destination) {
      return;
    }
    dispatch(moveScene(result.destination.index, result.source.index));
  }, []);

  return children(dropSceneHandler);
};
